import { useEffect } from 'react';

// The theme turns MUI's own scroll lock off for every modal, because its scrollbar compensation
// adds padding on top of the `scrollbar-gutter: stable` the baseline already reserves and shifts
// the page sideways. Pinning the body is the replacement: `overflow: hidden` on the scrolling
// element still lets touch and programmatic scrolling through, taking the page out of flow does
// not. The offset preserves the reading position, which the pin would otherwise discard.
export function useBodyScrollLock(locked: boolean): void {
    useEffect(() => {
        if (!locked) {
            return;
        }
        const { style } = document.body;
        const scrollY = window.scrollY;
        const previous = { position: style.position, top: style.top, left: style.left, right: style.right };
        Object.assign(style, { position: 'fixed', top: `${-scrollY}px`, left: '0', right: '0' });
        return (): void => {
            Object.assign(style, previous);
            window.scrollTo(0, scrollY);
        };
    }, [locked]);
}
